<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="700px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="isEditable && showOnly">
                        Produkt - <strong>{{ productData.name }}</strong>
                    </template>
                    <template v-else>
                        <template v-if="isNewProduct">
                            Dodaj produkt
                        </template>
                        <template v-else>
                            Edycja produktu - <strong>{{ productData.name }}</strong>
                        </template>
                    </template>
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="productModel.name"
                            label="Nazwa produktu"
                            outlined
                            dense
                            :error-messages="productErrors"
                        />
                    </v-col>
                </v-row>
            </div>
            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    <template>
                        Zapisz
                    </template>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import packages from '@/mixins/packages'
import { isEmpty } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'

export default {
    name: 'CampaignProductDialog',
    directives: { mask },
    mixins: [
        packages,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        isEditable: {
            type: Boolean
        },
        productData: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            productModel: {
                name: '',
                totalAmount: 0,
            },
        }
    },
    validations() {
        let rules = {
            productModel: {
                name: {
                    required,
                },
            },
        }

        return rules
    },
    computed: {
        isNewProduct() {
            return isEmpty(this.productData)
        },
        productErrors() {
            const errors = []

            if (!this.$v.productModel.name.$dirty) return errors
            !this.$v.productModel.name.required && errors.push('Proszę podać nazwę produktu.')

            return errors
        },
    },
    watch: {
        isOpen(value) {
            if (value && !isEmpty(this.productData)) {
                this.productModel = {
                    name: this.productData.name,
                    totalAmount: +this.productData.totalAmount,
                }
            }
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.setInitialData()
                this.$v.$reset()
            }, 500)
        },
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$emit('on-save', this.productModel)
            this.onClose()
        },
        setInitialData() {
            this.productModel = {
                name: '',
                totalAmount: 0,
            }
        },
    }
}
</script>